"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcContractInvoicing = exports.FieldsetContractInvoicing = void 0;
const FieldsetContractInvoicing_yaml_component_1 = __importDefault(require("./FieldsetContractInvoicing.yaml?component"));
exports.FieldsetContractInvoicing = FieldsetContractInvoicing_yaml_component_1.default;
const UcContractInvoicing_yaml_component_1 = __importDefault(require("./UcContractInvoicing.yaml?component"));
exports.UcContractInvoicing = UcContractInvoicing_yaml_component_1.default;
